module.exports = __webpack_public_path__ + "img/trufence_diagram_step3.124ff014.svg";